export default "__VITE_PUBLIC_ASSET__d8a32f77__"